import { gql } from "urql";
export const GetPriorityStatusesQuery = gql `
    query GetPriorityStatuses {
        priorityStatuses {
            priorityStatuses {
                priorityStatusId
                name
                colorHex
                sortOrder
                throwConfetti
                isMutable
                simpleEmailTemplateId
            }
        }
    }
`;
